import React, {Component} from "react"
import * as echarts from 'echarts'
import styled from "styled-components";
import Button from "../../components/Button";
import {observer} from "mobx-react";
import request from "../../utils/request";
import patient from "../../stores/patient";


const ChartContainer = styled.div`
    height: 40rem;
  width: 100%;
`
@observer
export class AdherenceChart extends Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.chartInstance = null;
    this.state = {
      reports: [],
      processedData: {},
    };
  }

  fetchReports = async () => {
    const res = await request('/api/adherenceStats/getByMedsReports', {
      patientID: patient.fields._id,
    });

    if(res.success) {
      const processedData = this.processData(res.data.byMedsReports);
      this.setState({
        reports: res.data.byMedsReports,
        processedData: processedData  // Store processed data in state
      }, () => {
        this.chartInstance = echarts.init(this.chartRef.current);
        this.setChartOptions();
      });
    } else {
      console.error('fetch weekly summary reports failed');
    }
  }
  componentDidMount() {
    this.fetchReports().then(() => {
      window.addEventListener('resize', this.chartInstance.resize);
    });
  }

  componentWillUnmount() {
    this.chartInstance.dispose();
    window.removeEventListener('resize', this.chartInstance.resize);
  }

  resetSlider = () => {
    const { start, end } = this.calculateSliderPositions();  // Adjusted to use months from processedData
    this.chartInstance.setOption({
      dataZoom: [
        {
          start,
          end,
        },
        {
          type: "inside",
          start,
          end,
        },
      ],
    })
  }

  processData = (reports) => {
    const monthlyData = {};

    reports.forEach(report => {
      const date = new Date(report.sunday_stop);
      const monthYear = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
      const key = `${report.uniqueID}-${report.prescription}`;

      if (!monthlyData[key]) {
        monthlyData[key] = {};
      }

      if (!monthlyData[key][monthYear]) {
        monthlyData[key][monthYear] = [];
      }

      monthlyData[key][monthYear].push(report.perc_med_adherent);
    });

    const seriesData = Object.entries(monthlyData).map(([key, months]) => {
      const medication = key.split('-')[1];
      const data = Object.entries(months).map(([month, values]) => {
        return {
          month,
          rate: values.reduce((acc, curr) => acc + curr, 0) / values.length // average adherence
        };
      }).sort((a, b) => a.month.localeCompare(b.month)); // sort by month

      return {
        name: medication,
        type: 'line',
        data: data.map(item => ({ value: item.rate, name: item.month }))
      };
    });

    return {
      months: [...new Set(seriesData.flatMap(item => item.data.map(d => d.name)))],
      series: seriesData
    };
  };

  calculateSliderPositions = () => {
    const months = this.state.processedData.months;  // Use processed data from state
    const totalMonths = months.length;
    const lastSixMonthsStart = Math.max(0, ((totalMonths - 6) / totalMonths) * 100);
    const lastSixMonthsEnd = 100;

    return { start: lastSixMonthsStart, end: lastSixMonthsEnd };
  };

  setChartOptions() {
    const { months, series } = this.state.processedData;  // Use processed data from state
    const { start, end } = this.calculateSliderPositions();  // Adjusted to use months from processedData

    const option = {
      title: {
        text: 'Patient Monthly Adherence Data',
        left: 'center',
        top: '5%',
        textStyle: {
          fontSize: 20,
        },
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params) => {
          let result = params[0].name + '<br>';
          params.forEach((param) => {
            result += param.marker + " " + param.seriesName + ': ' + param.value.toFixed(2) + '%<br>';
          });
          return result;
        }
      },
      legend: {
        data: series.map(item => item.name),
        top: '15%',
        left: 'center',
        itemGap: 20,
      },
      grid: {
        top: '25%',
        left: '3%',
        right: '4%',
        bottom: '20%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: months,
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: 100,
        axisLabel: {
          formatter: (value) => `${value.toFixed(2)}%`
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start,
          end,
          bottom: 0,
        },
        {
          type: 'inside',
          start,
          end,
        },
      ],
      series,
      graphic: [
        {
          type: 'text',
          left: 'center',
          bottom: '10%', // Adjust this value to position the text properly
          style: {
            text: 'The slider below can be used to change your date range',
            fontSize: 14,
            fill: '#000'
          }
        }
      ]
    }

    this.chartInstance.setOption(option)
  }
  render() {
    return (
      <ChartContainer>
        <div ref={this.chartRef}  style={{ height: 500, width: "100%", marginBottom: '1rem' }} />
        <Button color="blue" onClick={this.resetSlider} style={{width: "25%", marginLeft: "5rem"}}>Reset Slider</Button>
      </ChartContainer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/AdherenceStats/AdherenceChart.jsx